import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addControlledAdminsAPI,
  fetchControlledHierarchyAPI,
  removeControlledAdminsAPI,
} from "./controlledHierarchyAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  hierarchy: null,
  fetchStatus: "idle",
  addStatus: "idle",
  removeStatus: "idle",
  error: null,
};

export const fetchControlledHierarchy = createAsyncThunk(
  "controlledHierarchy/fetchControlledHierarchy",
  async (adminId, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchControlledHierarchyAPI(adminId);
      dispatch(
        showModal({
          message: "تم جلب بييانات الموظفين بنجاح",
          status: "success",
        })
      );
      return data;
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء جلب بيانات الموظفين",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

export const addControlledAdmins = createAsyncThunk(
  "controlledHierarchy/addControlledAdmins",
  async ({ adminId, newAdminIds }, { dispatch, rejectWithValue }) => {
    try {
      const data = await addControlledAdminsAPI(adminId, newAdminIds);
      dispatch(
        showModal({
          message: "تم اضافة الموظف بنجاح",
          status: "success",
        })
      );
      dispatch(fetchControlledHierarchy(adminId));
      return data;
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء اضافة الموظف",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

export const removeControlledAdmins = createAsyncThunk(
  "controlledHierarchy/removeControlledAdmins",
  async ({ adminId, removeAdminIds }, { dispatch, rejectWithValue }) => {
    try {
      const data = await removeControlledAdminsAPI(adminId, removeAdminIds);
      dispatch(
        showModal({
          message: "تم ازالة الموظف بنجاح",
          status: "success",
        })
      );
      dispatch(fetchControlledHierarchy(adminId));
      return data;
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء ازالة الموظف",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

const controlledHierarchySlice = createSlice({
  name: "controlledHierarchy",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchControlledHierarchy.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchControlledHierarchy.fulfilled, (state, action) => {
        state.hierarchy = action.payload;
        state.fetchStatus = "succeeded";
      })
      .addCase(fetchControlledHierarchy.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      })
      .addCase(addControlledAdmins.pending, (state) => {
        state.addStatus = "loading";
        state.error = null;
      })
      .addCase(addControlledAdmins.fulfilled, (state) => {
        state.addStatus = "succeeded";
      })
      .addCase(addControlledAdmins.rejected, (state, action) => {
        state.addStatus = "failed";
        state.error = action.payload;
      })
      .addCase(removeControlledAdmins.pending, (state) => {
        state.removeStatus = "loading";
        state.error = null;
      })
      .addCase(removeControlledAdmins.fulfilled, (state) => {
        state.removeStatus = "succeeded";
      })
      .addCase(removeControlledAdmins.rejected, (state, action) => {
        state.removeStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default controlledHierarchySlice.reducer;
